import { Component, OnInit } from '@angular/core';
import { FleetService } from 'src/app/services/fleet.service';
import { Router, ActivatedRoute } from '@angular/router';
import { getAnalytics, logEvent } from "firebase/analytics";
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})
export class OrderConfirmationComponent implements OnInit {
  customerData: any;
  orderData: any;
  showPFCharge: boolean = true;
  constructor(private fleetService: FleetService,
    private location:LocationStrategy,
    private router: ActivatedRoute) { 
// preventing back button in browser implemented by "Samba Siva"  


  }

  ngOnInit(): void {
    
    this._getDefaultAddress();
    this._getOrderDetails();
 
  }
  ngAfterViewInit() {
    const analytics = getAnalytics();

    logEvent(analytics, 'Front End Screen Views', {
      firebase_screen: 'Order Confirmation Page',
      firebase_screen_class: 'Order Confirmation Page'
    })
  }



  _getDefaultAddress() {
    this.fleetService._getDefaultDatas().subscribe((datas: any) => {
      console.log(datas);

      this.customerData = datas.response;
    })
  }

  _getOrderDetails() {
    let orderid: any = this.router.snapshot.queryParams['id'] || "";
    let id: any = sessionStorage.getItem('id')
    let tempid: any = this.router.snapshot.queryParams['id'] ? "" : sessionStorage.getItem('orderid') || "";
    this.fleetService._getOrderDetails_(id, orderid, tempid).subscribe((datas: any) => {
      console.log(datas)
      this.orderData = datas.response;
    })
  }

  pfadd(x: any,y: any,z: boolean){
    x = parseFloat(x)
    y = parseFloat(y)
    if(z){
      x = x+y;
    }
    return Number(x).toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR'
    });
  }

  convertToInt(num: any) {

    return Number(num)
  }
}
